<div class="schedule-display">
  <!-- Edit Schedule Button -->
  <div class="edit-button-container">
    <ion-button
      *ngIf="!disabled"
      class="page-button"
      color="secondary"
      (click)="openEditModal()">
      <ion-icon name="create-outline" slot="start"></ion-icon>
      {{ 'WORK_SCHEDULE.Edit_Schedule' | translate }}
    </ion-button>
  </div>

  <!-- Calendar Preview Section -->
  <div class="calendar-section">
    <div class="section-header">
      <span>{{ 'WORK_SCHEDULE.Effective_Schedule' | translate }}</span>
      <span class="hint-text">{{ 'WORK_SCHEDULE.Effective_Schedule_Hint' | translate }}</span>
    </div>

    <!-- Embedded Calendar -->
    <div class="calendar-container">
      <app-schedule-calendar
        [workDaysScheduleID]="calendarWorkDaysID"
        [daysOffScheduleID]="calendarDaysOffID"
        [subjectType]="subjectType"
        [subjectID]="subjectID"
        [showLegend]="true"
        [readonly]="true"
        [workDaysLabelKey]="workDaysLabelKey"
        [daysOffLabelKey]="daysOffLabelKey">
      </app-schedule-calendar>
    </div>
  </div>
</div>
